/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Open chat when mailto link is clicked.
document.addEventListener("DOMContentLoaded", function () {
    function openGorgiasChat() {
        if (window.GorgiasChat?.open) {
            console.log("Opening Gorgias Chat...");
            window.GorgiasChat.open();
        } else {
            console.warn("Gorgias Chat API not available yet. Retrying...");
            setTimeout(openGorgiasChat, 500); // Retry until it's available
        }
    }

    document.body.addEventListener("click", function (event) {
        const link = event.target.closest('a[href="mailto:hello@heysister.com"]');
        if (link) {
            event.preventDefault(); // Prevents the mailto default action
            console.log("Support link clicked. Trying to open chat...");
            openGorgiasChat();
        }
    });
});

(function () {
    const nativeFetch = window.fetch.bind(window);
    const REWARD_PROPERTY = "_cart_reward";
    const REWARD_BLOCK_PROPERTY = "_cart_reward_block";
    const REWARD_VARIANT_PROPERTY = "_cart_reward_variant_id";
    const OPT_OUT_STORAGE_PREFIX = "hey-sister:cart-reward-opt-out";
    const AUTO_ADD_FAILED_STORAGE_PREFIX = "hey-sister:cart-reward-auto-add-failed";
    const SNAPSHOT_STORAGE_PREFIX = "hey-sister:cart-reward-snapshot";

    let syncPromise = null;
    let pendingCart = null;
    let syncTimer = null;
    let scheduledSyncAt = 0;
    let offerIdCounter = 0;
    let latestCart = null;

    function getRoute(name, fallback) {
        return window.themeVariables?.routes?.[name] || fallback;
    }

    function getCartUrl() {
        return getRoute("cartUrl", "/cart");
    }

    function getCartAddUrl() {
        return getRoute("cartAddUrl", "/cart/add");
    }

    function getCartChangeUrl() {
        return getRoute("cartChangeUrl", "/cart/change");
    }

    function isCartPage() {
        return window.themeVariables?.settings?.pageType === "cart";
    }

    function readRewardConfigs() {
        const configs = new Map();

        document.querySelectorAll("[data-cart-reward-config]").forEach(function (element) {
            let parsed;

            try {
                parsed = JSON.parse(element.textContent || "[]");
            } catch (error) {
                console.error("Unable to parse cart reward config", error);
                return;
            }

            const entries = Array.isArray(parsed) ? parsed : [parsed];

            entries.forEach(function (entry) {
                const blockId = String(entry.blockId || "").trim();
                const variantId = String(entry.variantId || "").trim();
                const thresholdCents = Number(entry.thresholdCents);

                if (!blockId || !variantId || !Number.isFinite(thresholdCents) || thresholdCents <= 0) {
                    return;
                }

                const key = `${blockId}:${variantId}`;

                if (!configs.has(key)) {
                    configs.set(key, {
                        blockId,
                        variantId,
                        thresholdCents,
                        currency: entry.currency || window.themeVariables?.settings?.cartCurrency || "",
                        title: entry.title || "Cart reward",
                        unlockWithSubscription: entry.unlockWithSubscription === true || String(entry.unlockWithSubscription || "") === "true"
                    });
                }
            });
        });

        return Array.from(configs.values());
    }

    function findRewardConfig(blockId, variantId) {
        return readRewardConfigs().find(function (config) {
            return config.blockId === String(blockId || "") && config.variantId === String(variantId || "");
        });
    }

    function rememberCart(cart) {
        if (!cart || !Array.isArray(cart.items)) {
            return cart;
        }

        latestCart = cart;

        return cart;
    }

    function readInitialCartState() {
        const stateElement = document.querySelector("[data-cart-reward-cart-state]");

        if (!stateElement) {
            return null;
        }

        try {
            const cart = JSON.parse(stateElement.textContent || "{}");

            if (Array.isArray(cart.items)) {
                return rememberCart(cart);
            }
        } catch (error) {
            console.error("Unable to parse initial cart reward state", error);
        }

        return null;
    }

    function readVariantPriceMap() {
        const variantPrices = new Map();

        document.querySelectorAll("[data-cart-reward-variant-prices]").forEach(function (element) {
            let parsed;

            try {
                parsed = JSON.parse(element.textContent || "{}");
            } catch (error) {
                console.error("Unable to parse cart reward variant prices", error);
                return;
            }

            Object.keys(parsed || {}).forEach(function (variantId) {
                const data = parsed[variantId] || {};
                const sellingPlanPrices = {};

                Object.keys(data.sellingPlanPrices || {}).forEach(function (sellingPlanId) {
                    const price = Number(data.sellingPlanPrices[sellingPlanId]);

                    if (Number.isFinite(price) && price >= 0) {
                        sellingPlanPrices[String(sellingPlanId)] = price;
                    }
                });

                if (!variantPrices.has(String(variantId))) {
                    variantPrices.set(String(variantId), {
                        price: Number(data.price) || 0,
                        requiresShipping: data.requiresShipping !== false,
                        sellingPlanPrices
                    });
                }
            });
        });

        return variantPrices;
    }

    function getProperties(item) {
        return item?.properties || {};
    }

    function isManagedRewardItem(item, config) {
        if (String(item?.variant_id || "") === "68237386219824") {
            return !config || config.variantId === "68237386219824";
        }

        const properties = getProperties(item);
        const isReward = properties[REWARD_PROPERTY] === true || String(properties[REWARD_PROPERTY] || "") === "true";

        if (!isReward) {
            return false;
        }

        if (config && String(properties[REWARD_BLOCK_PROPERTY] || "") !== config.blockId) {
            return false;
        }

        if (config && String(properties[REWARD_VARIANT_PROPERTY] || item.variant_id || "") !== config.variantId) {
            return false;
        }

        return true;
    }

    function getQualifyingTotal(cart) {
        const itemsTotal = (cart.items || []).reduce(function (sum, item) {
            if (!item.requires_shipping || isManagedRewardItem(item)) {
                return sum;
            }

            return sum + (Number(item.final_line_price) || 0);
        }, 0);

        const cartLevelDiscounts = (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
            return sum + (Number(discount.total_allocated_amount) || 0);
        }, 0);

        return Math.max(itemsTotal - cartLevelDiscounts, 0);
    }

    function cartHasSubscriptionItem(cart) {
        return (cart.items || []).some(function (item) {
            return Boolean(item.selling_plan_allocation || item.selling_plan || item.has_selling_plan);
        });
    }

    function isRewardEligible(cart, config) {
        return getQualifyingTotal(cart) >= config.thresholdCents || (config.unlockWithSubscription && cartHasSubscriptionItem(cart));
    }

    function getCartIdentity(cart) {
        return String(cart?.token || "current");
    }

    function getStorageKey(prefix, cart, config) {
        return [
            prefix,
            getCartIdentity(cart),
            config.currency || "",
            config.blockId,
            config.variantId
        ].join(":");
    }

    function getStorageSuffix(config) {
        return [
            config.currency || "",
            config.blockId,
            config.variantId
        ].join(":");
    }

    function getStoredFlagForAnyCart(prefix, config, storage) {
        const keyPrefix = `${prefix}:`;
        const keySuffix = `:${getStorageSuffix(config)}`;

        for (let index = 0; index < storage.length; index += 1) {
            const key = storage.key(index);

            if (key && key.startsWith(keyPrefix) && key.endsWith(keySuffix) && storage.getItem(key) === "1") {
                return true;
            }
        }

        return false;
    }

    function getStoredFlag(prefix, cart, config, storage) {
        try {
            if (storage.getItem(getStorageKey(prefix, cart, config)) === "1") {
                return true;
            }

            if (!cart?.token) {
                return getStoredFlagForAnyCart(prefix, config, storage);
            }

            return false;
        } catch (error) {
            return false;
        }
    }

    function setStoredFlag(prefix, cart, config, storage, value) {
        try {
            const key = getStorageKey(prefix, cart, config);

            if (value) {
                storage.setItem(key, "1");
            } else {
                storage.removeItem(key);
            }
        } catch (error) {
            // Storage can be unavailable in private browsing; cart behavior still works for the current action.
        }
    }

    function hasOptedOut(cart, config) {
        return getStoredFlag(OPT_OUT_STORAGE_PREFIX, cart, config, window.localStorage);
    }

    function setOptedOut(cart, config, value) {
        setStoredFlag(OPT_OUT_STORAGE_PREFIX, cart, config, window.localStorage, value);
    }

    function hasAutoAddFailed(cart, config) {
        return getStoredFlag(AUTO_ADD_FAILED_STORAGE_PREFIX, cart, config, window.sessionStorage);
    }

    function setAutoAddFailed(cart, config, value) {
        setStoredFlag(AUTO_ADD_FAILED_STORAGE_PREFIX, cart, config, window.sessionStorage, value);
    }

    function getCartAddPath() {
        return new URL(`${getCartAddUrl()}.js`, window.location.origin).pathname;
    }

    function getCartChangePath() {
        return new URL(`${getCartChangeUrl()}.js`, window.location.origin).pathname;
    }

    function getCartUpdatePath() {
        return new URL(`${getCartUrl()}/update.js`, window.location.origin).pathname;
    }

    function getRequestUrl(input) {
        if (typeof input === "string") {
            return input;
        }

        if (input instanceof URL) {
            return input.toString();
        }

        if (input instanceof Request) {
            return input.url;
        }

        return "";
    }

    function getRequestMethod(input, init) {
        return String(init?.method || (input instanceof Request ? input.method : "GET")).toUpperCase();
    }

    function isCartAddRequest(input, init) {
        if (getRequestMethod(input, init) !== "POST") {
            return false;
        }

        const requestUrl = getRequestUrl(input);

        if (!requestUrl) {
            return false;
        }

        try {
            const pathname = new URL(requestUrl, window.location.origin).pathname;

            return pathname === getCartAddPath() || pathname.endsWith("/cart/add.js");
        } catch (error) {
            return false;
        }
    }

    function isCartChangeRequest(input, init) {
        if (getRequestMethod(input, init) !== "POST") {
            return false;
        }

        const requestUrl = getRequestUrl(input);

        if (!requestUrl) {
            return false;
        }

        try {
            const pathname = new URL(requestUrl, window.location.origin).pathname;

            return pathname === getCartChangePath() || pathname.endsWith("/cart/change.js");
        } catch (error) {
            return false;
        }
    }

    function isCartUpdateRequest(input, init) {
        if (getRequestMethod(input, init) !== "POST") {
            return false;
        }

        const requestUrl = getRequestUrl(input);

        if (!requestUrl) {
            return false;
        }

        try {
            const pathname = new URL(requestUrl, window.location.origin).pathname;

            return pathname === getCartUpdatePath() || pathname.endsWith("/cart/update.js");
        } catch (error) {
            return false;
        }
    }

    function isParsedRewardItem(item, config) {
        if (String(item?.id || "") === "68237386219824") {
            return !config || config.variantId === "68237386219824";
        }

        const properties = item?.properties || {};
        const isReward = properties[REWARD_PROPERTY] === true || String(properties[REWARD_PROPERTY] || "") === "true";

        if (!isReward) {
            return false;
        }

        if (config && String(properties[REWARD_BLOCK_PROPERTY] || "") !== config.blockId) {
            return false;
        }

        if (config && String(properties[REWARD_VARIANT_PROPERTY] || item.id || "") !== config.variantId) {
            return false;
        }

        return true;
    }

    function normalizeQuantity(quantity) {
        const parsedQuantity = parseInt(quantity, 10);

        return Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
    }

    function normalizeMutationQuantity(quantity) {
        const parsedQuantity = parseInt(quantity, 10);

        return Number.isFinite(parsedQuantity) && parsedQuantity >= 0 ? parsedQuantity : null;
    }

    function parseFormDataItems(formData) {
        const indexedItems = new Map();
        let hasIndexedItems = false;
        const singleItem = { properties: {} };

        formData.forEach(function (value, key) {
            let match = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);

            if (match) {
                hasIndexedItems = true;
                const index = Number(match[1]);
                const field = match[2];
                const item = indexedItems.get(index) || { index, properties: {} };
                item[field === "selling_plan" ? "selling_plan" : field] = value;
                indexedItems.set(index, item);
                return;
            }

            match = key.match(/^items\[(\d+)\]\[properties\]\[([^\]]+)\]$/);

            if (match) {
                hasIndexedItems = true;
                const index = Number(match[1]);
                const propertyName = match[2];
                const item = indexedItems.get(index) || { index, properties: {} };
                item.properties[propertyName] = value;
                indexedItems.set(index, item);
                return;
            }

            match = key.match(/^properties\[([^\]]+)\]$/);

            if (match) {
                singleItem.properties[match[1]] = value;
            } else if (key === "id" || key === "quantity" || key === "selling_plan") {
                singleItem[key] = value;
            }
        });

        const items = hasIndexedItems ? Array.from(indexedItems.values()).sort(function (a, b) {
            return a.index - b.index;
        }) : [singleItem];

        return items.filter(function (item) {
            return item.id !== undefined && item.id !== null && String(item.id).trim() !== "";
        }).map(function (item) {
            return {
                index: item.index,
                id: String(item.id),
                quantity: normalizeQuantity(item.quantity),
                selling_plan: item.selling_plan,
                properties: item.properties || {}
            };
        });
    }

    function appendRewardToFormData(formData, items, config) {
        const hasIndexedItems = items.some(function (item) {
            return item.index !== undefined;
        });
        const rewardItem = getRewardAddItem(config);

        if (hasIndexedItems) {
            const nextIndex = items.reduce(function (maxIndex, item) {
                return Math.max(maxIndex, Number(item.index) || 0);
            }, -1) + 1;
            const nextFormData = new FormData();

            formData.forEach(function (value, key) {
                nextFormData.append(key, value);
            });

            appendIndexedFormDataItem(nextFormData, nextIndex, rewardItem);

            return nextFormData;
        }

        const nextFormData = new FormData();
        const originalItem = items[0];

        formData.forEach(function (value, key) {
            if (key === "id" || key === "quantity" || key === "selling_plan" || /^properties\[[^\]]+\]$/.test(key)) {
                return;
            }

            nextFormData.append(key, value);
        });

        appendIndexedFormDataItem(nextFormData, 0, originalItem);
        appendIndexedFormDataItem(nextFormData, 1, rewardItem);

        return nextFormData;
    }

    function appendIndexedFormDataItem(formData, index, item) {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity || 1);

        if (item.selling_plan) {
            formData.append(`items[${index}][selling_plan]`, item.selling_plan);
        }

        Object.keys(item.properties || {}).forEach(function (propertyName) {
            formData.append(`items[${index}][properties][${propertyName}]`, item.properties[propertyName]);
        });
    }

    function parseJsonItems(payload) {
        const rawItems = Array.isArray(payload.items) ? payload.items : [payload];

        return rawItems.filter(function (item) {
            return item && item.id !== undefined && item.id !== null && String(item.id).trim() !== "";
        }).map(function (item) {
            return {
                id: String(item.id),
                quantity: normalizeQuantity(item.quantity),
                selling_plan: item.selling_plan,
                properties: item.properties || {}
            };
        });
    }

    function appendRewardToJsonPayload(payload, config) {
        const rewardItem = getRewardAddItem(config);

        if (Array.isArray(payload.items)) {
            return Object.assign({}, payload, {
                items: payload.items.concat([rewardItem])
            });
        }

        const originalItem = {
            id: payload.id,
            quantity: normalizeQuantity(payload.quantity),
            properties: payload.properties || {}
        };

        if (payload.selling_plan) {
            originalItem.selling_plan = payload.selling_plan;
        }

        const nextPayload = Object.assign({}, payload, {
            items: [originalItem, rewardItem]
        });

        delete nextPayload.id;
        delete nextPayload.quantity;
        delete nextPayload.selling_plan;
        delete nextPayload.properties;

        return nextPayload;
    }

    function getRewardAddItem(config) {
        return {
            id: config.variantId,
            quantity: 1,
            properties: {
                [REWARD_PROPERTY]: "true",
                [REWARD_BLOCK_PROPERTY]: config.blockId,
                [REWARD_VARIANT_PROPERTY]: config.variantId
            }
        };
    }

    function setJsonContentType(init, input) {
        const nextInit = Object.assign({}, init || {});
        const headers = new Headers(nextInit.headers || (input instanceof Request ? input.headers : undefined));
        headers.set("Content-Type", "application/json");
        nextInit.headers = headers;

        return nextInit;
    }

    function buildFetchArgsWithBody(input, init, body, forceJson) {
        const nextInit = forceJson ? setJsonContentType(init, input) : Object.assign({}, init || {});
        nextInit.body = body;

        if (!nextInit.method) {
            nextInit.method = getRequestMethod(input, init);
        }

        if (input instanceof Request && init === undefined) {
            return [new Request(input, nextInit)];
        }

        return [input, nextInit];
    }

    function buildFetchArgsForUrl(url, input, init, body, forceJson) {
        const nextInit = forceJson ? setJsonContentType(init, input) : Object.assign({}, init || {});
        nextInit.body = body;
        nextInit.method = "POST";

        if (!nextInit.credentials && input instanceof Request) {
            nextInit.credentials = input.credentials;
        }

        return [url, nextInit];
    }

    async function readJsonResponse(response) {
        try {
            return await response.clone().json();
        } catch (error) {
            return null;
        }
    }

    function isVariantNotFoundCartError(response, payload) {
        const status = Number(payload?.status || response.status);
        const description = String(payload?.description || payload?.message || "").toLowerCase();

        return status === 422 && description.includes("cannot find variant");
    }

    function logRewardAddFailure(config, payload) {
        console.error("Unable to add cart reward; retrying cart add without reward", {
            blockId: config.blockId,
            variantId: config.variantId,
            error: payload
        });
    }

    async function readAddRequestBody(input, init) {
        const body = init && Object.prototype.hasOwnProperty.call(init, "body") ? init.body : undefined;

        if (body instanceof FormData) {
            return {
                items: parseFormDataItems(body),
                appendReward: function (config) {
                    return buildFetchArgsWithBody(input, init, appendRewardToFormData(body, this.items, config), false);
                }
            };
        }

        if (body instanceof URLSearchParams) {
            const formData = new FormData();
            body.forEach(function (value, key) {
                formData.append(key, value);
            });

            return {
                items: parseFormDataItems(formData),
                appendReward: function (config) {
                    return buildFetchArgsWithBody(input, init, appendRewardToFormData(formData, this.items, config), false);
                }
            };
        }

        if (typeof body === "string") {
            try {
                const payload = JSON.parse(body);

                return {
                    items: parseJsonItems(payload),
                    appendReward: function (config) {
                        return buildFetchArgsWithBody(input, init, JSON.stringify(appendRewardToJsonPayload(payload, config)), true);
                    }
                };
            } catch (error) {
                return null;
            }
        }

        if (input instanceof Request && body === undefined) {
            const contentType = input.headers.get("Content-Type") || "";

            if (contentType.includes("application/json")) {
                const payload = await input.clone().json();

                return {
                    items: parseJsonItems(payload),
                    appendReward: function (config) {
                        return buildFetchArgsWithBody(input, init, JSON.stringify(appendRewardToJsonPayload(payload, config)), true);
                    }
                };
            }

            if (contentType.includes("form")) {
                const formData = await input.clone().formData();

                return {
                    items: parseFormDataItems(formData),
                    appendReward: function (config) {
                        return buildFetchArgsWithBody(input, init, appendRewardToFormData(formData, this.items, config), false);
                    }
                };
            }
        }

        return null;
    }

    function parseFormPayload(formData) {
        const payload = {};

        formData.forEach(function (value, key) {
            const updatesMatch = key.match(/^updates\[(.*)\]$/);

            if (key === "updates[]") {
                if (!Array.isArray(payload.updates)) {
                    payload.updates = [];
                }

                payload.updates.push(value);
            } else if (updatesMatch) {
                if (!payload.updates || Array.isArray(payload.updates)) {
                    payload.updates = {};
                }

                payload.updates[updatesMatch[1]] = value;
            } else if (key === "sections") {
                payload.sections = Array.isArray(value) ? value : String(value).split(",").map(function (section) {
                    return section.trim();
                }).filter(Boolean);
            } else {
                payload[key] = value;
            }
        });

        return payload;
    }

    function getPayloadFromUrl(input) {
        const requestUrl = getRequestUrl(input);

        if (!requestUrl) {
            return null;
        }

        const searchParams = new URL(requestUrl, window.location.origin).searchParams;
        const payload = {};

        searchParams.forEach(function (value, key) {
            payload[key] = value;
        });

        return Object.keys(payload).length > 0 ? payload : null;
    }

    async function readCartMutationRequest(input, init) {
        const body = init && Object.prototype.hasOwnProperty.call(init, "body") ? init.body : undefined;

        if (body instanceof FormData) {
            return { payload: parseFormPayload(body) };
        }

        if (body instanceof URLSearchParams) {
            const formData = new FormData();
            body.forEach(function (value, key) {
                formData.append(key, value);
            });

            return { payload: parseFormPayload(formData) };
        }

        if (typeof body === "string") {
            try {
                return { payload: JSON.parse(body) };
            } catch (error) {
                return null;
            }
        }

        if (input instanceof Request && body === undefined) {
            const contentType = input.headers.get("Content-Type") || "";

            if (contentType.includes("application/json")) {
                return { payload: await input.clone().json() };
            }

            if (contentType.includes("form")) {
                return { payload: parseFormPayload(await input.clone().formData()) };
            }
        }

        const payloadFromUrl = getPayloadFromUrl(input);

        return payloadFromUrl ? { payload: payloadFromUrl } : null;
    }

    function findCartItemForChangePayload(cart, payload) {
        if (payload.line !== undefined && payload.line !== null && String(payload.line).trim() !== "") {
            const lineIndex = parseInt(payload.line, 10) - 1;

            return (cart.items || [])[lineIndex] || null;
        }

        const id = String(payload.id || "").trim();

        if (!id) {
            return null;
        }

        return (cart.items || []).find(function (item) {
            return String(item.key || "") === id || String(item.variant_id || "") === id;
        }) || null;
    }

    function getChangePayloadUpdates(cart, payload) {
        const quantity = normalizeMutationQuantity(payload.quantity);
        const item = quantity !== null ? findCartItemForChangePayload(cart, payload) : null;

        if (!item) {
            return null;
        }

        return {
            [item.key || String(item.variant_id)]: quantity
        };
    }

    function cloneUpdatesForCart(updates, cart) {
        if (Array.isArray(updates)) {
            return (cart.items || []).map(function (item, index) {
                const quantity = normalizeMutationQuantity(updates[index]);

                return quantity === null ? normalizeQuantity(item.quantity) : quantity;
            });
        }

        if (updates && typeof updates === "object") {
            return Object.assign({}, updates);
        }

        return {};
    }

    function getUpdateQuantityForItem(updates, item, index) {
        if (Array.isArray(updates)) {
            if (!Object.prototype.hasOwnProperty.call(updates, index)) {
                return null;
            }

            return normalizeMutationQuantity(updates[index]);
        }

        if (!updates || typeof updates !== "object") {
            return null;
        }

        const itemKey = String(item.key || "");
        const variantId = String(item.variant_id || "");

        if (itemKey && Object.prototype.hasOwnProperty.call(updates, itemKey)) {
            return normalizeMutationQuantity(updates[itemKey]);
        }

        if (variantId && Object.prototype.hasOwnProperty.call(updates, variantId)) {
            return normalizeMutationQuantity(updates[variantId]);
        }

        return null;
    }

    function setUpdateForItem(updates, cart, item, quantity) {
        if (Array.isArray(updates)) {
            const index = (cart.items || []).indexOf(item);

            if (index >= 0) {
                updates[index] = quantity;
            }

            return;
        }

        updates[item.key || String(item.variant_id)] = quantity;
    }

    function getCartItemUnitPrice(item) {
        const finalPrice = Number(item.final_price);

        if (Number.isFinite(finalPrice) && finalPrice >= 0) {
            return finalPrice;
        }

        const quantity = normalizeQuantity(item.quantity);
        const finalLinePrice = Number(item.final_line_price);

        return Number.isFinite(finalLinePrice) && quantity > 0 ? finalLinePrice / quantity : 0;
    }

    function getProjectedQualifyingTotal(cart, updates) {
        const itemsTotal = (cart.items || []).reduce(function (sum, item, index) {
            if (!item.requires_shipping || isManagedRewardItem(item)) {
                return sum;
            }

            const updatedQuantity = getUpdateQuantityForItem(updates, item, index);
            const quantity = updatedQuantity === null ? normalizeQuantity(item.quantity) : updatedQuantity;

            return sum + getCartItemUnitPrice(item) * quantity;
        }, 0);

        return Math.max(itemsTotal, 0);
    }

    function getRewardItemsToRemoveAfterUpdates(cart, updates) {
        const projectedTotal = getProjectedQualifyingTotal(cart, updates);
        const rewardItems = [];

        readRewardConfigs().forEach(function (config) {
            if (projectedTotal >= config.thresholdCents || (config.unlockWithSubscription && cartHasSubscriptionItem(cart))) {
                return;
            }

            (cart.items || []).forEach(function (item) {
                if (isManagedRewardItem(item, config)) {
                    storeRewardSnapshot(cart, config, item);
                    rewardItems.push(item);
                }
            });
        });

        return rewardItems;
    }

    function getPayloadWithRewardRemovals(cart, payload, updates) {
        const rewardItems = getRewardItemsToRemoveAfterUpdates(cart, updates);

        if (rewardItems.length === 0) {
            return null;
        }

        const nextUpdates = cloneUpdatesForCart(updates, cart);

        rewardItems.forEach(function (item) {
            setUpdateForItem(nextUpdates, cart, item, 0);
        });

        return Object.assign({}, payload, {
            updates: nextUpdates
        });
    }

    async function getCartForMutationInterception() {
        if (latestCart) {
            return latestCart;
        }

        return fetchCart();
    }

    async function getCartChangeRewardRemovalPayload(changePayload) {
        if (!changePayload || readRewardConfigs().length === 0) {
            return null;
        }

        const cart = await getCartForMutationInterception();
        const updates = getChangePayloadUpdates(cart, changePayload);

        if (!updates) {
            return null;
        }

        const payload = getPayloadWithRewardRemovals(cart, changePayload, updates);

        if (!payload) {
            return null;
        }

        delete payload.line;
        delete payload.id;
        delete payload.quantity;

        if (!payload.sections) {
            payload.sections = ["mini-cart"];
        }

        return payload;
    }

    async function getCartUpdateRewardRemovalPayload(updatePayload) {
        if (!updatePayload || updatePayload.updates === undefined || readRewardConfigs().length === 0) {
            return null;
        }

        const cart = await getCartForMutationInterception();
        const updates = cloneUpdatesForCart(updatePayload.updates, cart);

        return getPayloadWithRewardRemovals(cart, updatePayload, updates);
    }

    function getAddedItemsQualifyingTotal(cart, items) {
        const variantPrices = readVariantPriceMap();
        let total = 0;

        for (const item of items) {
            if (isParsedRewardItem(item)) {
                continue;
            }

            let variantData = variantPrices.get(String(item.id));

            if (!variantData) {
                const existingCartItem = (cart.items || []).find(function (cartItem) {
                    return String(cartItem.variant_id) === String(item.id);
                });

                if (existingCartItem) {
                    variantData = {
                        price: Number(existingCartItem.final_price) || 0,
                        requiresShipping: existingCartItem.requires_shipping !== false
                    };
                }
            }

            if (!variantData) {
                return null;
            }

            if (variantData.requiresShipping !== false) {
                let itemPrice = Number(variantData.price) || 0;
                const sellingPlanPrice = item.selling_plan
                    ? Number(variantData.sellingPlanPrices?.[String(item.selling_plan)])
                    : NaN;

                if (Number.isFinite(sellingPlanPrice) && sellingPlanPrice >= 0) {
                    itemPrice = sellingPlanPrice;
                }

                total += itemPrice * normalizeQuantity(item.quantity);
            }
        }

        return total;
    }

    async function getCartForAddInterception() {
        return getCartForMutationInterception();
    }

    async function getRewardConfigForAddRequest(addRequest) {
        const configs = readRewardConfigs();

        if (configs.length === 0 || !addRequest || addRequest.items.length === 0) {
            return null;
        }

        if (addRequest.items.some(function (item) {
            return isParsedRewardItem(item);
        })) {
            return null;
        }

        const cart = await getCartForAddInterception();
        const addedQualifyingTotal = getAddedItemsQualifyingTotal(cart, addRequest.items);
        const addsSubscription = addRequest.items.some(function (item) {
            return Boolean(item.selling_plan);
        });

        if (addedQualifyingTotal === null && !addsSubscription) {
            return null;
        }

        const projectedTotal = getQualifyingTotal(cart) + (addedQualifyingTotal || 0);

        return configs.find(function (config) {
            const managedItems = (cart.items || []).filter(function (item) {
                return isManagedRewardItem(item, config);
            });

            const eligible = projectedTotal >= config.thresholdCents || (config.unlockWithSubscription && (cartHasSubscriptionItem(cart) || addsSubscription));

            return eligible && managedItems.length === 0 && !hasOptedOut(cart, config) && !hasAutoAddFailed(cart, config);
        }) || null;
    }

    async function getCartAddFetchArgs(input, init) {
        if (!isCartAddRequest(input, init)) {
            return null;
        }

        const addRequest = await readAddRequestBody(input, init);
        const config = await getRewardConfigForAddRequest(addRequest);

        if (!config) {
            return null;
        }

        return {
            args: addRequest.appendReward(config),
            config
        };
    }

    async function getCartChangeFetchArgs(input, init) {
        if (!isCartChangeRequest(input, init)) {
            return null;
        }

        const mutationRequest = await readCartMutationRequest(input, init);
        const payload = mutationRequest ? await getCartChangeRewardRemovalPayload(mutationRequest.payload) : null;

        if (!payload) {
            return null;
        }

        return buildFetchArgsForUrl(`${getCartUrl()}/update.js`, input, init, JSON.stringify(payload), true);
    }

    async function getCartUpdateFetchArgs(input, init) {
        if (!isCartUpdateRequest(input, init)) {
            return null;
        }

        const mutationRequest = await readCartMutationRequest(input, init);
        const payload = mutationRequest ? await getCartUpdateRewardRemovalPayload(mutationRequest.payload) : null;

        if (!payload) {
            return null;
        }

        return buildFetchArgsWithBody(input, init, JSON.stringify(payload), true);
    }

    window.fetch = async function (input, init) {
        const cartAddRequest = await getCartAddFetchArgs(input, init);

        if (cartAddRequest) {
            const response = await nativeFetch.apply(window, cartAddRequest.args);

            if (response.ok) {
                return response;
            }

            const responseJson = await readJsonResponse(response);

            if (!isVariantNotFoundCartError(response, responseJson)) {
                return response;
            }

            logRewardAddFailure(cartAddRequest.config, responseJson);
            setAutoAddFailed(latestCart || {}, cartAddRequest.config, true);

            return reconcileCartMutationResponse(await nativeFetch(input, init), { returnCartPayload: false });
        }

        if (isCartAddRequest(input, init)) {
            return reconcileCartMutationResponse(await nativeFetch(input, init), { returnCartPayload: false });
        }

        const cartChangeFetchArgs = await getCartChangeFetchArgs(input, init);

        if (cartChangeFetchArgs) {
            return reconcileCartMutationResponse(await nativeFetch.apply(window, cartChangeFetchArgs), { returnCartPayload: true });
        }

        if (isCartChangeRequest(input, init)) {
            return reconcileCartMutationResponse(await nativeFetch(input, init), { returnCartPayload: true });
        }

        const cartUpdateFetchArgs = await getCartUpdateFetchArgs(input, init);

        if (cartUpdateFetchArgs) {
            return reconcileCartMutationResponse(await nativeFetch.apply(window, cartUpdateFetchArgs), { returnCartPayload: true });
        }

        if (isCartUpdateRequest(input, init)) {
            return reconcileCartMutationResponse(await nativeFetch(input, init), { returnCartPayload: true });
        }

        return nativeFetch(input, init);
    };

    function getRewardImage(item) {
        return item.image || item.featured_image?.url || item.featured_image || "";
    }

    function getRewardTitle(item) {
        return item.product_title || item.title || item.variant_title || "Cart reward";
    }

    function storeRewardSnapshot(cart, config, item) {
        if (!item) {
            return;
        }

        const snapshot = {
            image: getRewardImage(item),
            title: getRewardTitle(item),
            url: String(item.variant_id) === "68237386219824" ? "" : (item.url || ""),
            variantId: String(item.variant_id || config.variantId)
        };

        try {
            window.localStorage.setItem(getStorageKey(SNAPSHOT_STORAGE_PREFIX, cart, config), JSON.stringify(snapshot));
        } catch (error) {
            // The generic reward template remains available if storage is blocked.
        }
    }

    function getRewardSnapshot(cart, config) {
        try {
            const rawSnapshot = window.localStorage.getItem(getStorageKey(SNAPSHOT_STORAGE_PREFIX, cart, config));
            const snapshot = rawSnapshot ? JSON.parse(rawSnapshot) : null;

            if (!snapshot || String(snapshot.variantId || "") !== config.variantId) {
                return null;
            }

            return snapshot;
        } catch (error) {
            return null;
        }
    }

    async function fetchCart() {
        const response = await nativeFetch(`${getCartUrl()}.js`, {
            cache: "no-store",
            credentials: "same-origin"
        });

        if (!response.ok) {
            throw new Error("Unable to fetch cart");
        }

        return rememberCart(await response.json());
    }

    async function addReward(config) {
        const response = await nativeFetch(`${getCartAddUrl()}.js`, {
            body: JSON.stringify({
                items: [
                    {
                        id: config.variantId,
                        quantity: 1,
                        properties: {
                            [REWARD_PROPERTY]: "true",
                            [REWARD_BLOCK_PROPERTY]: config.blockId,
                            [REWARD_VARIANT_PROPERTY]: config.variantId
                        }
                    }
                ],
                sections: ["mini-cart"]
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            }
        });
        const responseJson = await response.json();

        if (!response.ok) {
            throw new Error(responseJson.description || "Unable to add cart reward");
        }

        const cart = await fetchCart();
        cart.sections = responseJson.sections || cart.sections;

        return cart;
    }

    async function updateCart(updates) {
        const response = await nativeFetch(`${getCartUrl()}/update.js`, {
            body: JSON.stringify({
                updates,
                sections: ["mini-cart"]
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            }
        });
        const cart = await response.json();

        if (!response.ok) {
            throw new Error(cart.description || "Unable to update cart reward");
        }

        return rememberCart(cart);
    }

    function isCartPayload(payload) {
        return payload && Array.isArray(payload.items) && (
            Object.prototype.hasOwnProperty.call(payload, "token") ||
            Object.prototype.hasOwnProperty.call(payload, "item_count") ||
            Object.prototype.hasOwnProperty.call(payload, "total_price")
        );
    }

    function buildJsonResponse(response, payload) {
        const headers = new Headers(response.headers);
        headers.set("Content-Type", "application/json; charset=utf-8");
        headers.delete("Content-Length");

        return new Response(JSON.stringify(payload), {
            status: response.status,
            statusText: response.statusText,
            headers
        });
    }

    function applyCartSectionsToPayload(payload, cart) {
        if (!payload || typeof payload !== "object" || !cart?.sections) {
            return payload;
        }

        return Object.assign({}, payload, {
            sections: cart.sections
        });
    }

    async function reconcileCartRewards(cartFromMutation) {
        const configs = readRewardConfigs();

        if (configs.length === 0) {
            return cartFromMutation;
        }

        let cart = cartFromMutation && Array.isArray(cartFromMutation.items) ? rememberCart(cartFromMutation) : await fetchCart();

        for (const config of configs) {
            const eligible = isRewardEligible(cart, config);
            const updates = getRewardUpdates(cart, config, eligible);

            if (Object.keys(updates).length > 0) {
                cart = await updateCart(updates);
                continue;
            }

            const managedItems = cart.items.filter(function (item) {
                return isManagedRewardItem(item, config);
            });

            managedItems.forEach(function (item) {
                storeRewardSnapshot(cart, config, item);
            });

            if (eligible && managedItems.length === 0 && !hasOptedOut(cart, config) && !hasAutoAddFailed(cart, config)) {
                try {
                    cart = await addReward(config);
                    setAutoAddFailed(cart, config, false);
                } catch (error) {
                    console.error("Unable to auto-add cart reward", error);
                    setAutoAddFailed(cart, config, true);
                }
            }
        }

        return rememberCart(cart);
    }

    async function reconcileCartMutationResponse(response, options) {
        if (!response.ok || readRewardConfigs().length === 0) {
            return response;
        }

        const payload = await readJsonResponse(response);

        if (!payload) {
            return response;
        }

        const payloadIsCart = isCartPayload(payload);
        const cart = await reconcileCartRewards(payloadIsCart ? payload : null);

        if (!cart || !Array.isArray(cart.items)) {
            return response;
        }

        if (options?.returnCartPayload || payloadIsCart) {
            return buildJsonResponse(response, cart);
        }

        return buildJsonResponse(response, applyCartSectionsToPayload(payload, cart));
    }

    function emitCartEvents(cart) {
        rememberCart(cart);

        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart }
        }));
    }

    function getOfferTemplate(config) {
        return Array.from(document.querySelectorAll("[data-cart-reward-offer-template]")).find(function (template) {
            return template.getAttribute("data-cart-reward-block") === config.blockId;
        });
    }

    function applyOfferSnapshot(offer, snapshot) {
        if (!snapshot) {
            return;
        }

        const imageWrapper = offer.querySelector(".cart-reward-gift-offer__image");
        const titleElement = offer.querySelector(".product-item-meta__title");

        if (imageWrapper && snapshot.image) {
            const image = document.createElement("img");
            image.className = "line-item__image";
            image.loading = "lazy";
            image.sizes = "(max-width: 740px) 80px, 92px";
            image.src = snapshot.image;
            image.alt = snapshot.title || "";

            imageWrapper.innerHTML = "";
            imageWrapper.appendChild(image);
        }

        if (titleElement && snapshot.title) {
            const replacement = snapshot.url ? document.createElement("a") : document.createElement("span");

            replacement.className = titleElement.className;
            replacement.textContent = snapshot.title;

            if (snapshot.url) {
                replacement.href = snapshot.url;
            }

            titleElement.replaceWith(replacement);
        }
    }

    function prepareOfferClone(offer, config, snapshot) {
        const toggle = offer.querySelector("[data-cart-reward-toggle]");

        if (!toggle) {
            return;
        }

        offerIdCounter += 1;
        const id = `cart-reward-offer-${config.blockId}-${config.variantId}-${offerIdCounter}`;
        const label = toggle.nextElementSibling;

        toggle.id = id;
        toggle.checked = false;
        toggle.disabled = false;
        toggle.setAttribute("data-cart-reward-block", config.blockId);
        toggle.setAttribute("data-cart-reward-variant-id", config.variantId);

        if (label && label.tagName === "LABEL") {
            label.setAttribute("for", id);
        }

        applyOfferSnapshot(offer, snapshot);
    }

    function removeRenderedOffers() {
        document.querySelectorAll("[data-cart-reward-offer-row]").forEach(function (row) {
            row.remove();
        });

        document.querySelectorAll("[data-cart-reward-offer]").forEach(function (offer) {
            offer.remove();
        });
    }

    function renderOffers(cart, configs) {
        removeRenderedOffers();

        if (!cart || !Array.isArray(cart.items)) {
            return;
        }

        const containers = Array.from(document.querySelectorAll("[data-cart-items-container]"));

        if (containers.length === 0) {
            return;
        }

        configs.forEach(function (config) {
            const eligible = isRewardEligible(cart, config);
            const managedItems = cart.items.filter(function (item) {
                return isManagedRewardItem(item, config);
            });
            const snapshot = managedItems.length > 0 ? {
                image: getRewardImage(managedItems[0]),
                title: getRewardTitle(managedItems[0]),
                url: String(managedItems[0].variant_id) === "68237386219824" ? "" : (managedItems[0].url || ""),
                variantId: String(managedItems[0].variant_id || config.variantId)
            } : getRewardSnapshot(cart, config);
            const shouldShowOffer = eligible && managedItems.length === 0 && (hasOptedOut(cart, config) || hasAutoAddFailed(cart, config));
            const template = shouldShowOffer ? getOfferTemplate(config) : null;

            if (!template || !template.content || !template.content.firstElementChild) {
                return;
            }

            containers.forEach(function (container) {
                const offer = template.content.firstElementChild.cloneNode(true);
                prepareOfferClone(offer, config, snapshot);

                if (container.getAttribute("data-cart-container-type") === "table") {
                    const row = document.createElement("tr");
                    const cell = document.createElement("td");

                    row.className = "line-item line-item--cart-reward line-item--cart-reward-offer-row";
                    row.setAttribute("data-cart-reward-offer-row", "");
                    row.setAttribute("data-cart-reward-block", config.blockId);
                    row.setAttribute("data-cart-reward-variant-id", config.variantId);
                    cell.colSpan = 3;
                    cell.appendChild(offer);
                    row.appendChild(cell);
                    container.appendChild(row);
                } else {
                    const badges = container.querySelector(".cart-rewards__item-badges");
                    container.insertBefore(offer, badges || null);
                }
            });
        });
    }

    function getRewardUpdates(cart, config, eligible) {
        const updates = {};

        if (config.variantId === "68237386219824") {
            (cart.items || []).forEach(function (item) {
                if (String(item.variant_id) === "66928302293296" && isManagedRewardItem(item)) {
                    updates[item.key] = 0;
                }
            });
        }
        const managedItems = (cart.items || []).filter(function (item) {
            return isManagedRewardItem(item, config);
        });

        managedItems.forEach(function (item) {
            storeRewardSnapshot(cart, config, item);
        });

        if (!eligible || hasOptedOut(cart, config)) {
            managedItems.forEach(function (item) {
                updates[item.key] = 0;
            });

            return updates;
        }

        managedItems.forEach(function (item, index) {
            if (index === 0 && item.quantity !== 1) {
                updates[item.key] = 1;
            } else if (index > 0) {
                updates[item.key] = 0;
            }
        });

        return updates;
    }

    async function handleMutatedCart(cart, configs) {
        emitCartEvents(cart);

        if (isCartPage()) {
            window.location.reload();
            return;
        }

        if (!cart.sections?.["mini-cart"]) {
            renderOffers(cart, configs);
        }
    }

    async function syncCart(cartFromEvent) {
        if (syncPromise) {
            pendingCart = cartFromEvent || pendingCart;
            return syncPromise;
        }

        syncPromise = (async function () {
            const configs = readRewardConfigs();

            if (configs.length === 0) {
                removeRenderedOffers();
                return;
            }

            let cart = cartFromEvent && Array.isArray(cartFromEvent.items) ? rememberCart(cartFromEvent) : await fetchCart();

            for (const config of configs) {
                const eligible = isRewardEligible(cart, config);
                const updates = getRewardUpdates(cart, config, eligible);

                if (Object.keys(updates).length > 0) {
                    cart = await updateCart(updates);
                    await handleMutatedCart(cart, configs);
                    return;
                }

                const managedItems = cart.items.filter(function (item) {
                    return isManagedRewardItem(item, config);
                });

                managedItems.forEach(function (item) {
                    storeRewardSnapshot(cart, config, item);
                });

                if (eligible && managedItems.length === 0 && !hasOptedOut(cart, config) && !hasAutoAddFailed(cart, config)) {
                    try {
                        cart = await addReward(config);
                        setAutoAddFailed(cart, config, false);
                        await handleMutatedCart(cart, configs);
                    } catch (error) {
                        console.error("Unable to auto-add cart reward", error);
                        setAutoAddFailed(cart, config, true);
                        renderOffers(cart, configs);
                    }

                    return;
                }
            }

            renderOffers(cart, configs);
        })();

        try {
            await syncPromise;
        } finally {
            syncPromise = null;

            if (pendingCart) {
                const nextCart = pendingCart;
                pendingCart = null;
                scheduleSync(nextCart, 25);
            }
        }
    }

    function scheduleSync(cart, delay, preserveEarlier) {
        const delayMs = delay || 0;
        const nextSyncAt = Date.now() + delayMs;

        if (syncTimer && preserveEarlier && scheduledSyncAt && scheduledSyncAt <= nextSyncAt) {
            pendingCart = cart || pendingCart;
            return;
        }

        window.clearTimeout(syncTimer);
        scheduledSyncAt = nextSyncAt;
        syncTimer = window.setTimeout(function () {
            syncTimer = null;
            scheduledSyncAt = 0;
            syncCart(cart).catch(function (error) {
                console.error("Unable to sync cart rewards", error);
            });
        }, delayMs);
    }

    function getRewardToggleContainer(toggle) {
        return toggle.closest(".cart-reward-gift__toggle") || toggle.parentElement;
    }

    function getRewardToggleLabel(toggle) {
        const container = getRewardToggleContainer(toggle);

        if (!container) {
            return null;
        }

        if (toggle.id) {
            const label = Array.from(container.querySelectorAll("label")).find(function (candidate) {
                return candidate.htmlFor === toggle.id;
            });

            if (label) {
                return label;
            }
        }

        return toggle.nextElementSibling?.tagName === "LABEL" ? toggle.nextElementSibling : container.querySelector("label");
    }

    function setRewardToggleLoading(toggle) {
        const container = getRewardToggleContainer(toggle);
        const label = getRewardToggleLabel(toggle);

        if (!container || !label) {
            return;
        }

        container.setAttribute("data-cart-reward-toggle-loading", "");
        toggle.setAttribute("aria-busy", "true");
        label.setAttribute("aria-live", "polite");
        label.setAttribute("aria-atomic", "true");

        if (!label.hasAttribute("data-cart-reward-original-label")) {
            label.setAttribute("data-cart-reward-original-label", label.textContent || "");
        }

        label.textContent = toggle.dataset.cartRewardLoadingLabel || "Loading...";
    }

    function clearRewardToggleLoading(toggle) {
        const container = getRewardToggleContainer(toggle);
        const label = getRewardToggleLabel(toggle);

        if (container) {
            container.removeAttribute("data-cart-reward-toggle-loading");
        }

        toggle.removeAttribute("aria-busy");

        if (label?.hasAttribute("data-cart-reward-original-label")) {
            label.textContent = label.getAttribute("data-cart-reward-original-label") || "";
            label.removeAttribute("data-cart-reward-original-label");
            label.removeAttribute("aria-live");
            label.removeAttribute("aria-atomic");
        }
    }

    async function onRewardToggleChanged(event) {
        const toggle = event.target.closest("[data-cart-reward-toggle]");

        if (!toggle) {
            return;
        }

        const config = findRewardConfig(toggle.getAttribute("data-cart-reward-block"), toggle.getAttribute("data-cart-reward-variant-id"));

        if (!config) {
            return;
        }

        toggle.disabled = true;
        setRewardToggleLoading(toggle);

        try {
            let cart = await fetchCart();

            if (toggle.checked) {
                setOptedOut(cart, config, false);
                setAutoAddFailed(cart, config, false);
                cart = await addReward(config);
            } else {
                setOptedOut(cart, config, true);

                const lineKey = toggle.getAttribute("data-cart-reward-line-key");
                const managedItem = (cart.items || []).find(function (item) {
                    return lineKey ? item.key === lineKey : isManagedRewardItem(item, config);
                });

                storeRewardSnapshot(cart, config, managedItem);

                if (lineKey) {
                    cart = await updateCart({ [lineKey]: 0 });
                }
            }

            await handleMutatedCart(cart, readRewardConfigs());
        } catch (error) {
            console.error("Unable to update cart reward toggle", error);
            toggle.checked = !toggle.checked;
            toggle.disabled = false;
            clearRewardToggleLoading(toggle);
        }
    }

    function isCartChangeUrl(url) {
        try {
            const pathname = new URL(url, window.location.origin).pathname;
            const cartChangePath = new URL(getCartChangeUrl(), window.location.origin).pathname;

            return pathname === cartChangePath || pathname.endsWith("/cart/change");
        } catch (error) {
            return false;
        }
    }

    function getCartChangePayloadFromUrl(url) {
        const searchParams = new URL(url, window.location.origin).searchParams;

        return {
            line: searchParams.get("line"),
            id: searchParams.get("id"),
            quantity: searchParams.get("quantity")
        };
    }

    async function submitCartPageChange(link) {
        try {
            const payload = await getCartChangeRewardRemovalPayload(getCartChangePayloadFromUrl(link));

            if (!payload) {
                window.location.href = link;
                return;
            }

            const response = await nativeFetch(`${getCartUrl()}/update.js`, {
                body: JSON.stringify(payload),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            });

            if (!response.ok) {
                throw new Error("Unable to update cart reward with cart page change");
            }

            window.location.href = getCartUrl();
        } catch (error) {
            console.error("Unable to include cart reward removal with cart page change", error);
            window.location.href = link;
        }
    }

    function onCartPageQuantityLinkClicked(event) {
        if (!isCartPage()) {
            return;
        }

        const link = event.target.closest("line-item-quantity a[href]");

        if (!link || !isCartChangeUrl(link.href)) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        submitCartPageChange(link.href);
    }

    function onCartPageQuantityChanged(event) {
        if (!isCartPage()) {
            return;
        }

        const input = event.target.closest("line-item-quantity input[data-line]");

        if (!input) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const link = `${getCartChangeUrl()}?quantity=${encodeURIComponent(input.value)}&line=${encodeURIComponent(input.getAttribute("data-line"))}`;
        submitCartPageChange(link);
    }

    readInitialCartState();

    document.addEventListener("click", onCartPageQuantityLinkClicked, true);
    document.addEventListener("change", onCartPageQuantityChanged, true);
    document.addEventListener("change", onRewardToggleChanged);

    document.documentElement.addEventListener("cart:updated", function (event) {
        rememberCart(event.detail?.cart);
    });

    document.documentElement.addEventListener("cart:refresh", function (event) {
        rememberCart(event.detail?.cart);
        scheduleSync(event.detail?.cart || null, 25, true);
    });

    document.addEventListener("DOMContentLoaded", function () {
        scheduleSync(null, 100);
    });

    window.addEventListener("pageshow", function () {
        scheduleSync(null, 300);
    });
})();
